import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";

const Consulting = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Consultant Company</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=" "
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consulting Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/consulting.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service bottom">
                            <p className="prose-lg wow fadeUp">
                                Our Salesforce consulting services are designed to enhance your sales, marketing, and customer service operations. With extensive CRM consulting experience, we assist companies across various industries—such as professional services, retail, IT, manufacturing, finance, banking, and healthcare—harness the full potential of Salesforce to drive success.
                            </p>
                            <div className="row mt-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Unlock Salesforce Potential!</h3>
                                        <p className="prose-lg wow fadeUp">Codezix’s consultants know how to leverage Salesforce to boost your customer acquisition, conversion, and retention.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Get Salesforce</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix">
                            <div className='explore-heading text-left'>
                                <h2>Highlights about Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times, with 16 years of expertise in CRM consulting. </li>
                                    <li className="wow fadeUp prose-lg">Extensive industry expertise across manufacturing, retail, professional services, healthcare, banking, telecommunications, and more. </li>
                                </ul>
                            </div>
                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className='achieve-project mb-4'>
                            <button className="prose-md">What makes Codezix different</button>
                            <h3>We ensure project success, no matter the circumstances</h3>
                            <p>Codezix does not pass mere project administration off as project management, which, unfortunately, is a common practice in the market. We practice real project management, ensuring project success for our clients no matter what.</p>
                            <Link to="/"> <button>See how we do it&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>What Our Salesforce Consultants Do</h2>
                                <p className="wow fadeUp prose-lg text-left">If you plan to implement Salesforce or improve your existing solution, Codezix provides comprehensive consulting, which includes:</p>
                            </div>


                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/icons-tem/r-1.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Defining the business objectives that Salesforce is meant to support. Whether you need to improve reports with enhanced visibility, shorten long sales cycles or case resolution times, launch effective email marketing campaigns, or automate sales and customer service processes, Salesforce consulting from Codezix helps you tackle your challenges quickly and efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/icons-tem/r-2.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Once your business goals are clear, the next step is mapping them to Salesforce features. At this stage, Codezix helps you select the right Salesforce functionality—whether default or custom—to effectively achieve those objectives. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/icons-tem/r-3.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Recommending the most suitable Salesforce edition. Selecting the right edition ensures that your business challenges are addressed without paying for unnecessary features. Codezix analyzes your requirements and suggests the edition that perfectly aligns with your business needs.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/icons-tem/r-4.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Designing sales, customer service, and marketing processes in Salesforce Sales, Service, and Marketing Clouds. For example, we automate sales and customer service workflows, create personalized customer journeys, design targeted advertising campaigns, and much more, all aimed at helping our clients achieve their business goals with Salesforce.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/icons-tem/r-5.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Building a user adoption strategy. To ensure your users master the new system, Codezix creates a tailored user adoption strategy, which includes iterative user training, timely support from a Salesforce admin, detailed release notes, and rewards for advanced Salesforce users.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product bottom_footer mt-5">
                                <div className='explore-heading text-left'>
                                    <h2>Choose Your Service Option </h2>
                                </div>
                                <div class="row mt-5">
                                    <div className="col-md-4">
                                        <div className="service-option">
                                            <h3>Salesforce implementation consulting</h3>
                                            <p className="prose-md wow fadeUp">
                                                We analyze your business needs and offer the best-suited way to address them with Salesforce capabilities.
                                            </p><br /><br /><br />
                                            <Link><button>I need this&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="service-option">
                                            <h3>Salesforce improvement consulting</h3>
                                            <p className="prose-md wow fadeUp">
                                                We assess your Salesforce solution and provide a comprehensive integration and customization plan to enhance its functionality and better meet your business needs.
                                            </p>
                                            <Link><button>I need this&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="service-option">
                                            <h3>Salesforce migration consulting</h3>
                                            <p className="prose-md wow fadeUp">
                                                We help ensure a smooth migration process and maintain the continuity of your business operations throughout.
                                            </p><br /><br /><br />
                                            <Link><button>I need this&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Salesforce Products We Work With </h2>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/sales-cloud">
                                                <h3 class="mt-0">Sales Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/service-cloud">
                                                <h3 class="mt-0">Service Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/marketing-cloud">
                                                <h3 class="mt-0">Marketing Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/community-cloud">
                                                <h3 class="mt-0">Community Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/finencial-service-cloud">
                                                <h3 class="mt-0">Financial Services Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/non-profit">
                                                <h3 class="mt-0">Nonprofit Cloud</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/cpq">
                                                <h3 class="mt-0">Salesforce CPQ</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="software-develop salesf-box height-100">
                                            <Link to="/salesforce/consulting#">
                                                <h3 class="mt-0">Salesforce Chatter</h3>
                                                <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Challenges We Solve</h2>
                                    <p className="wow fadeUp prose-lg text-left">We develop solutions to address various challenges within Salesforce, including:</p>
                                </div>
                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"><strong>Low win rates due to an inconsistent sales process.</strong> We help enhance or completely transform your sales process using Salesforce Sales Cloud. To streamline process automation, we recommend leveraging Salesforce's built-in features or implementing custom code-based solutions. This approach enables the creation of a clear, well-organized sales process, providing visibility into its execution and guiding sales representatives toward successfully closing deals. With Salesforce consulting, businesses can achieve a 26% increase in win rates and a 28% boost in sales revenue.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Inefficient customer service caused by prolonged case resolution times.</strong> We can assist you in enhancing your customer service quality by utilizing Salesforce Service Cloud's built-in or customized case management features. With our guidance, you’ll learn how to effectively use its automated case assignment, prioritization, and escalation tools to boost your service agents' productivity, leading to a 31% faster case resolution rate.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Ineffective lead conversion processes resulting in low conversion rates. </strong> We demonstrate how to boost your lead conversion rates by designing effective omni-channel marketing campaigns and leveraging Salesforce Marketing Cloud's digital advertising capabilities. Our team will guide you in developing tailored customer communication strategies, enabling you to engage with a broad audience while delivering highly personalized experiences. This approach can result in a 30% improvement in lead conversion rates.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Get Your Salesforce Needs Addressed</h3>
                                            <p className="prose-lg wow fadeUp">Looking to maximize the value of your sales, customer service, and marketing efforts? Our team can provide expert guidance on how to achieve it.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button> Turn to our experts </button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Consulting;